

















































































import { Vue, Component } from 'vue-property-decorator';
import { PartnerInstance } from 'types';

@Component({
    props: ['partners']
})
export default class PartnersList extends Vue {
    removeConnection(partner: PartnerInstance) {
        this.$emit('remove-connection', partner);
    }
}
